<template>
  <div :class="[useSize]">
    <div
      class="w-full h-full rounded-full overflow-hidden justify-center flex items-center justify-center bg-opacity-10 p-2"
      :class="[useBackground]"
      :aria-label="`Progress is ${type}`"
    >
      <icon-svg :icon="useIconName" :class="[useIconClass, useIconColor]" />
    </div>
  </div>
</template>

<script>
import IconSvg from "./IconSvg";
export default {
  name: "ProgressIndicator",
  inheritAttrs: false,
  components: {
    IconSvg,
  },
  props: {
    size: {
      default: 8,
      type: Number,
      required: false,
      validator: (value) => {
        return [8, 10, 12, 16, 24, 32, 48, 64].includes(value);
      },
    },
    type: {
      default: "neutral",
      type: String,
      validator: (value) => {
        return ["neutral", "up", "down"].includes(value);
      },
    },
  },
  computed: {
    useSize() {
      return `w-${this.size} h-${this.size}`;
    },
    useIconClass() {
      // w-8 w-10 w-12 w-16 w-24 w-32 w-48 w-64
      return `w-${this.size} h-${this.size} text-gray-400`;
    },
    useIconColor() {
      if (this.type === "neutral") {
        return "text-gray-500";
      } else if (this.type == "up") {
        return "text-success";
      } else {
        return "text-error";
      }
    },
    useBackground() {
      if (this.type === "neutral") {
        return "bg-gray-500";
      } else if (this.type == "up") {
        return "bg-success";
      } else {
        return "bg-error";
      }
    },
    useIconName() {
      if (this.type === "neutral") {
        return "neutral";
      } else if (this.type == "up") {
        return "thin-arrow-up";
      } else {
        return "thin-arrow-down";
      }
    },
  },
};
</script>
